export default {
    figures: {
        cad: {
            dialogTitle: 'CADから特許図面へ変換',
            close: '閉じる',
            uploadTitle: '3Dファイルをインポート',
            uploadDesc: 'STEP、STP、IGES、IGS、STL、OBJ、PLY、GLTF、GLB形式に対応',
            selectFile: 'ファイルを選択',
            unsupportedFormat: 'サポートされていないファイル形式です',
            insertSuccess: '図面に挿入しました',
            insertFailed: '図面への挿入に失敗しました',
            insert: '図面に保存',
            modeStandard: '標準',
            modePatent: '特許',
            lineWidth: '線幅',
            hatching: 'ハッチング',
            hatchingGap: 'ハッチング間隔',
            edgeThreshold: 'エッジしきい値',
            clipToggle: '断面',
            clipFlip: '反転',
            explodeToggle: '分解図',
            explodeUnsupported: '現在のモデルは単一構造のため、分解図に対応していません',
            explodeAxisView: '視点',
            loadingParser: 'パーサーを初期化中...',
            loadingModel: 'モデルを解析中...',
            loadingGeneric: '読み込み中...',
            noGeometryParsed: 'このファイルから利用可能なジオメトリを解析できませんでした。モデルがソリッドとして縫合されていない可能性があります。',
            errUnsupportedFormat: 'サポートされていないファイル形式です。STEP、STP、IGES、IGS、STL、OBJ、PLY、GLTF、GLB のいずれかをアップロードしてください。',
            errOutOfMemory: 'モデルが複雑すぎるため、ブラウザのメモリが不足し読み込みに失敗しました。モデルの簡略化、部品数の削減、またはSTL形式での書き出しをお試しください。',
            errParseFailed: 'ファイルの解析に失敗しました。破損している、またはこの形式の有効なファイルでない可能性があります。',
            errFileReadFailed: 'ファイルの読み込みに失敗しました。ファイルが存在することを確認して再試行してください。',
            errUnknown: '読み込みに失敗しました。再試行するか、別のファイルをお使いください。',
            errWorkerUnavailable: 'このブラウザはバックグラウンド解析に対応していません。ブラウザを変更またはアップグレードしてください。',
            loadingTransferring: 'ジオメトリを構築中...',
            errParseTimeout: '解析がタイムアウトしたため停止しました（5分以上未完了）。部品数またはジオメトリの複雑度が高すぎます。モデルを簡略化する、必要な部品のみを残す、またはSTL形式で書き出してからアップロードしてください。',
            stuckHint: '解析に想定以上の時間がかかっています。部品数が多い、またはジオメトリが複雑すぎる可能性があります。5分を超えると自動的に停止します。モデルの簡略化、必要な部品のみを残す、またはSTL形式での書き出しをお試しください。',
            errParserInitTimeout: 'パーサーの読み込みに失敗しました。ネットワークの問題でリソースを完全にダウンロードできなかった可能性があります。接続を確認し、ページを再読み込みして再試行してください。',
            largeFileHint: 'ファイルサイズが大きいため（{size}）、解析に数十秒かかる場合があります。しばらくお待ちください。',
        },
        canvas: {
            loading: '画像を更新中です。しばらくお待ちください...',
            aiUpdating: 'AI が図面を編集中です...',
            emptyTitle: '作成したい図面の説明を始めましょう',
            emptyDesc: '右側のダイアログに詳しい説明を入力してください',
            annotationInfo: {
                button: '引用番号',
                loading: '読み込み中…',
                empty: 'この図に引用番号情報はありません',
                numeralHeader: '番号',
                componentHeader: '部品名',
                editHint: '部品名をクリックして編集',
                addRow: '引用番号を追加',
                addNumeralPlaceholder: '番号（数字）',
                addComponentPlaceholder: '部品名',
                addComponentReuseHint: '既存の名称が使用されます',
                addCancel: 'キャンセル',
                addConfirm: '追加',
                deleteConfirm: 'この図から番号 {numeral} を削除しますか？',
                deleteCancel: 'キャンセル',
                deleteOk: '削除',
                errorNumeralFormat: '番号は数字または数字＋英字のみ',
                errorNumeralRequired: '番号を入力してください',
                errorComponentRequired: '部品名を入力してください',
            },
        },
        annotationConfirm: {
            reconfirmBanner: 'このプロジェクトには確定済みの引用番号マップがあります。現在は再調整モードです。',
            defaultTitle: '引用番号マップを確認してください',
            colNumeral: '番号',
            colFeature: '特徴（部品名）',
            colFigures: '適用図面',
            colEmbodiment: '実施形態',
            colAnchor: '標記ポイント',
            figuresEmpty: '（未選択）',
            embodimentPlaceholder: '例：第1実施形態',
            addRow: '＋ 行を追加',
            confirm: '確認してラベリング開始',
            confirmed: '確認済み',
            warnNumeralDup: '番号 "{numeral}" が重複しています',
            warnComponentDup: '特徴名 "{name}" が重複しています。正しいか確認してください',
            warnNewRowNoFigure: '新しい行には適用図面を選択してください',
            warnNoFigure: '図面未選択 — すべての図面に適用されます',
            submitHint: '引用番号マップを確認しました。合計 {count} 件',
            submitHintNext: '。最初の図面からラベリングを開始：{figureNo}',
        },
        fineTune: {
            button: '微調整',
            preparing: '準備中',
            title: '部分微調整',
            close: '閉じる',
            placeholder: '選択した領域をどのように修正するか入力してください...',
            selectionCount: '{count} 個のグリッドを選択済み',
            clear: 'クリア',
            addOperation: '指示を追加',
            submitAll: 'すべて送信',
            operationTitle: '指示 {index}',
            remove: '削除',
        },
        maskEdit: {
            title: 'マスク画像編集',
            preparing: '編集を準備しています...',
            notSupported: 'この画像はまだAI編集に対応していません。保存後に再試行してください。',
            hint: '編集したい領域を塗ってください',
            brushSize: 'ブラシサイズ',
            undo: '一筆戻す',
            clear: 'クリア',
            placeholder: 'この領域をどう修正するか入力...',
            close: '閉じる',
            cancel: 'キャンセル',
            submit: '送信',
        },
        panel: {
            title: '図面エディター',
            reset: 'リセット',
            submit: '保存',
            newFigureGenerated: '新しい図が生成され、サムネイルリストに追加されました。現在の図には未保存の変更があるため、自動的に切り替えられていません。',
            unsavedChanges: '現在の図には未保存の変更があります。切り替えるとこれらの変更は自動的に保存されません。続行しますか？',
            unsavedChangesTitle: '未保存の変更',
            continueSwitch: '続ける',
            cancel: 'キャンセル',
            resetConfirmTitle: 'リセット確認',
            resetConfirm: '現在の変更を破棄して、最後に保存した状態に戻しますか？',
            confirmReset: 'リセットを確認',
            uploadFailed: 'アップロード失敗：{fileName}',
            renameFailed: '名前の変更に失敗しました。後でもう一度お試しください',
        },
        uploadDialog: {
            title: '図をアップロード',
            aiGenerate: 'AI生成',
            aiGenerateDesc: 'AIでプロフェッショナルな図を生成',
            normalUpload: 'ファイルをアップロード',
            normalUploadDesc: 'ローカルから画像ファイルをアップロード',
            fromFile: 'ファイルから',
            fromFileDesc: 'アップロード済みファイルから選択',
            cadImport: '3Dモデルインポート',
            cadImportDesc: 'STEP/STLファイルをアップロードし、特許図面に変換',
            editFigure: '図面を編集',
        },
        vsdx: {
            converting: 'Visio ファイルを変換中...',
            success: '変換に成功し、{count} 枚の図面を生成しました',
            partialSuccess: '{success} 枚の図面を生成、{failed} ページの変換に失敗しました',
            failed: 'Visio の変換に失敗しました',
            legacyUnsupported: '.vsd/.vdx/.vss 形式は未対応です。Visio で .vsdx として保存してから再度アップロードしてください',
        },
        attachmentPicker: {
            title: '添付画像を選択',
            subtitle: 'プロジェクト添付の元画像、または Word/PDF から抽出された画像を選択できます',
            addToCanvasSubtitle: '画像をクリックしてキャンバスに追加',
            empty: 'このプロジェクトに利用可能な画像はありません',
            loadFailed: '添付画像の読み込みに失敗しました。しばらくしてから再試行してください。',
            importFailed: '添付画像の取り込みに失敗しました。しばらくしてから再試行してください。',
            sourcePrefix: '元ファイル: ',
            tableImage: '表画像',
            selectedCount: '{count} 枚の画像が選択されています',
            cancel: 'キャンセル',
            confirm: '確定',
        },
        collapsePanel: '閉じる',
        exportPdf: 'PDF 出力',
        chat: {
            title: 'Hiro',
            historyTitle: '履歴',
            newChat: '新しいチャット',
            languageLabel: 'モデル出力言語',
            welcome: 'こんにちは！様々な技術図面を生成するお手伝いをできます。希望の図面を説明してください。要件に基づいてプロフェッショナルな図面を作成します。',
            suggestedTasksWithFigures: [
                { title: '整合性チェック', desc: 'すべての Fig ラベルと明細書の対応関係をスキャン', prompt: 'すべての図面ラベルと明細書の整合性を確認してください' },
                { title: '図面説明の生成', desc: '現在のすべての Fig ラベルからテキストを一括生成', prompt: '現在のすべての図面ラベルに基づいて図面説明を生成してください' },
                { title: '番号管理', desc: '一括リネーム/順序変更/参照同期', prompt: '図面番号の一括管理（リネーム、順序変更、参照同期）をお願いします' },
            ],
            suggestedTasksNoFigures: [
                { title: '書類から図面を生成', desc: '既存資料から技術方案を自動抽出して Fig を生成', prompt: '開示書/請求項/明細書から図面を生成してください' },
                { title: '既存図面の最適化・補完', desc: '既存図面をアップロードし、自動最適化・不足 Fig を補充', prompt: '既存の図面を最適化・補完してください' },
                { title: 'すべての図面を作成', desc: 'ゼロから要件を説明し、全図面セットを順次生成', prompt: 'ゼロからすべての図面を作成してください' },
            ],
            inputPlaceholder: '希望する図面を説明してください。{\'@\'}でリソースをメンション...',
            mentionResource: 'リソースをメンション',
            awaitingGeneration: '図面が生成中です。しばらくお待ちください...',
            fineTunePrompt: {
                targetFigure: '対象図面：{figureName}',
                targetFileId: '対象図面 file_id：{fileId}',
                gridRule: 'グリッドルール：対象図面は10x10グリッドに分割され、行はA-Jで上から下、列は1-10で左から右；A1は左上角、J10は右下角。',
                editTarget: 'draw_patent_figuresを呼び出す際、このfile_idをfile_ids_to_editに入れて編集対象として使用してください。',
                instruction: '対象図面「{figureName}」の以下の10x10グリッド領域のみ局所微調整を行い、他の図面は変更しないでください。',
                selectedCells: '{index}. 選択エリア：{cells}',
                modifyRequirement: '   修正要求：{instruction}',
            },
            maskEditPrompt: {
                targetFigure: '対象図面：{figureName}',
                instruction: '塗った領域のみを編集してください：{instruction}',
            },
            history: {
                title: '履歴',
                empty: '会話履歴がありません',
                search: '会話を検索...',
                rename: '名前を変更',
                delete: '削除',
                defaultTitle: '新しい会話',
                today: '今日',
                yesterday: '昨日',
                lastWeek: '過去1週間',
                lastMonth: '過去1ヶ月',
                older: 'それ以前',
            },
        },
    },
};
